<template>
  <card :has-settings="false" :has-subtitle="false" title="Forms" class="form-submission-card" v-bind="cardAttrs">
    <template #content>
      <form-submissions-list :data="formSubmissions" @updated="updateFormSubmissions"></form-submissions-list>
    </template>
    <template #headerUtils v-if="canFillForms">
      <b-modal v-model="fillFormOpen" :component="getFillFormComponent()" :events="{save: updateFormSubmissions}" :props="{ patientId, patientMonitorId, readonly: true }" :can-cancel="false"></b-modal>
      <button class="button is-outlined fill-button mr-2" :class="`${isPopupMode ? 'is-white' : 'is-primary'}`" @click="fillForm">
        New Entry
      </button>
      <slot name="headerUtils"></slot>
    </template>
  </card>
</template>

<script>
import Card from "@/components/card/Card";
import FormFill from "@/components/form_builder/FormFill";
import to from "@/lib/to";
import FormSubmissionsList from "@/components/form_builder/FormSubmissionsList";
export default {
name: "FormSubmissionListCard",
  components: {FormSubmissionsList, Card},
  props: {
    patientId: {
      type: [String, Number],
      required: true
    },
    patientMonitorId: {
      type: [String, Number],
      required: false,
      default: null
    },
    isPopupMode: {
      type: Boolean,
      default: false
    },
    cardAttrs: {
      type: Object,
      default: () => { return {} }
    }
  },
  methods: {
    async updateFormSubmissions() {
      const [err, response] = await to(this.http.get(`/form_submissions/all?patient_id=${this.patientId}`, { skipLoading: true }))
      if (!err) {
        this.formSubmissions = response.data
        this.$emit('submissions-loaded', this.formSubmissions)
      }
    },
    fillForm() {
      this.fillFormOpen = true
    },
    getFillFormComponent() {
      return FormFill
    }
  },
  mounted() {
    this.updateFormSubmissions()
  },
  data() {
    return {
      formSubmissions: [],
      canFillForms: this.$can('Fill', 'FormBuilder'),
      fillFormOpen: false,
    }
  }
}
</script>

<style scoped lang="scss">
  .fill-button {
    padding-top: 6px;
  }
  .form-submission-card {
    :deep() {
      td {
        word-break: break-word;
      }
      .b-table.is-inner-table {
        overflow-x: auto;
        width: 100%;
      }
      .monitoring-card__content > div {
        margin: 15px 0;
        width: 100%;
        max-height: 230px;
      }
    }
  }
</style>
